import { render, staticRenderFns } from "./assetImportLogDetailList.vue?vue&type=template&id=55a91324&scoped=true"
import script from "./assetImportLogDetailList.vue?vue&type=script&lang=js"
export * from "./assetImportLogDetailList.vue?vue&type=script&lang=js"
import style0 from "./assetImportLogDetailList.vue?vue&type=style&index=0&id=55a91324&prod&lang=scss&scoped=true"
import style1 from "./assetImportLogDetailList.vue?vue&type=style&index=1&id=55a91324&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a91324",
  null
  
)

export default component.exports